/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyRub = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14 13H9V3h5c2.757 0 5 2.243 5 5s-2.243 5-5 5m0-12H7v12H3v2h4v2H3v2h4v4h2v-4h5v-2H9v-2h5c3.86 0 7-3.141 7-7s-3.14-7-7-7"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyRub as CurrencyRub };
